import regeneratorRuntime from "/app/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import getNFTServices from '@/api/nft';
import { makeAddressInfo, makeBlockDetailLink, makeNFTInfo } from '@/utils/link';
import clss from 'classnames';
import { bignumberMinus, toNFTID } from '@/utils/string';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var cache = {};
var nftService = getNFTServices();
function NFTIDLink(param) {
    var nftid = param.nftid, className = param.className;
    var router = useRouter();
    var ref = useState(''), blockHash = ref[0], setBlockHash = ref[1];
    var getNFTDetail = useCallback(_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var cacheKey, res;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cacheKey = nftid.toString(16);
                    if (!cache[cacheKey]) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", cache[cacheKey]);
                case 3:
                    _ctx.next = 5;
                    return nftService.getNFTByID({
                        id: nftid.toString(),
                        querytype: 'simple'
                    });
                case 5:
                    res = _ctx.sent;
                    if (res === null || res === void 0 ? void 0 : res.Result) {
                        cache[cacheKey] = res === null || res === void 0 ? void 0 : res.Result;
                    }
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.Result);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        nftid
    ]);
    var gotoNFTDetail = useCallback(_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    getNFTDetail().then(function(nft) {
                        if (nft && nft.Address) {
                            var linkUrl = !!nft.IsPieceHashed ? makeNFTInfo(bignumberMinus(nftid, nft.BaseID || nftid).toString(), nftid) : makeAddressInfo(nft.Address);
                            router.push(linkUrl);
                        }
                    });
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        getNFTDetail,
        nftid
    ]);
    var linkUrl1 = useMemo(function() {
        return makeBlockDetailLink(blockHash);
    }, [
        blockHash
    ]);
    return(/*#__PURE__*/ _jsx("div", {
        className: clss(className, 'inline text-primary cursor-pointer ml-[6px]'),
        onClick: gotoNFTDetail,
        children: toNFTID(0, nftid).split(' ')[1]
    }));
}
export default NFTIDLink;
